import { render, staticRenderFns } from "./SchoolMember.vue?vue&type=template&id=7cbb923a&scoped=true&"
import script from "./SchoolMember.vue?vue&type=script&lang=js&"
export * from "./SchoolMember.vue?vue&type=script&lang=js&"
import style0 from "./SchoolMember.vue?vue&type=style&index=0&id=7cbb923a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbb923a",
  null
  
)

export default component.exports